/*
 * O que vem depois do último post: os botões do tópico e os tópicos
 * sugeridos. Só aparece quando o stream chegou ao fim — no meio de um tópico
 * longo os posts seguintes ainda não carregaram, e o rodapé ficaria no meio.
 */
import Component from 'flarum/common/Component';
import SuggestedTopics from './SuggestedTopics';
import TopicFooter from './TopicFooter';
import TopicMap, { hasBottomTopicMap } from './TopicMap';
import { topicSettings } from '../ui';
export default class TopicEnd extends Component {
  view() {
    const {
      discussion,
      stream,
      page
    } = this.attrs;
    if (!stream || !stream.viewingEnd()) return null;
    const footer = topicSettings.footer();
    const suggested = topicSettings.suggested();
    if (!footer && !suggested) return null;
    return m("div", {
      className: "CanelaTopicEnd"
    }, topicSettings.map() && hasBottomTopicMap(discussion) && m(TopicMap, {
      discussion: discussion,
      position: "bottom"
    }), footer && m(TopicFooter, {
      discussion: discussion,
      page: page
    }), suggested && [m(SuggestedTopics, {
      key: discussion.id(),
      discussion: discussion
    })]);
  }
}
flarum.reg.add('ramon-canela', 'forum/topic/components/TopicEnd', TopicEnd);